//模块名：[{配置1},{配置2}]
module.exports = {
    // example:新增角色页面，路由地址system/permission/role/add
    // 'role': { //三级路由
    //     'add': { //四级路由
    //         controllerName: 'addRole', //替换的controller.js文件名
    //         templateName: 'addRole.html', //替换的html文件名
    //     },
    //     'list': { //四级路由
    //         controllerName: 'addRole', //替换的controller.js文件名
    //         templateName: 'addRole.html', //替换的html文件名
    //     },
    // },
    // 'remainCtrl': {
    //     controllerName: 'mainCtrl'
    // }
}






//////////////////
// WEBPACK FOOTER
// ./build/redevConfig.js
// module id = Vmhg
// module chunks = 0